import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { H1 } from '../../../components/atoms/Heading/Heading';
import { Text } from '../../../components/atoms/Text/Text';
import { SearchField } from '../../../components/atoms/SearchField/SearchField';
import { LayoutProps, StyledBox } from './ProviderListHeader.styles';
import { messages } from './messages';

export type ProviderListHeaderProps = LayoutProps & {
  placeholder?: string;
  onSearchChange?: (str: string) => void;
  isMultibanking?: boolean;
  headerMessage?: MessageDescriptor;
};

export const ProviderListHeader: React.FC<ProviderListHeaderProps> = ({
  placeholder = '',
  onSearchChange,
  searchBoxShadow = false,
  wideSearchField = false,
  isMultibanking = false,
  headerMessage = messages.selectYourBank,
  children,
}) => {
  return (
    <>
      <StyledBox mb="normal" searchBoxShadow={searchBoxShadow} wideSearchField={wideSearchField}>
        <H1>
          <FormattedMessage {...headerMessage} />
        </H1>
        {onSearchChange && (
          <SearchField
            onChange={(e) => onSearchChange(e.currentTarget.value)}
            placeholder={placeholder}
            inputProps={{ 'data-testid': 'provider-list-search-field' }}
          />
        )}
      </StyledBox>
      {isMultibanking && (
        <Text size="normal" color="secondary" mb="medium">
          <FormattedMessage {...messages.multibanking} />
        </Text>
      )}
      {children}
    </>
  );
};
